import { useTrialPicker } from 'trial-components-library/hooks/UpmarketMotion/useTrialPicker';
import { ButtonWithDemoExitConfirmation } from '../../../components/DemoExitConfirmation';
import { GlobalToolbarLink, ICON_NAMES } from '../../../components/GlobalToolbar/Components';
import { newListItemStyles } from '../../../components/GlobalToolbar/stylesheets';
import { useAppSelector } from '../../../hooks';
import useIsPaidPortal from '../../../hooks/useIsPaidPortal';
import useIsProfessionalOrEnterpriseTrial from '../../../hooks/useIsProfessionalOrEnterpriseTrial';
import { selectPortalId, selectScopes } from '../../../selectors';
import memoWithDisplayName from '../../../utils/memoWithDisplayName';
import { TRIAL_PICKER_BUTTON_ID } from '../constants';
import { useTrialBadge } from '../hooks';
import { jsx as _jsx } from "react/jsx-runtime";
export const StartTrialButton = memoWithDisplayName('StartTrialButton', () => {
  const scopes = useAppSelector(selectScopes);
  const portalId = useAppSelector(selectPortalId);
  const {
    isPaidPortal,
    isPaidLoaded
  } = useIsPaidPortal();
  const {
    isProOrEntTrial,
    isProOrEntTrialLoaded
  } = useIsProfessionalOrEnterpriseTrial();
  const [showStartTrialButton] = useTrialPicker(isPaidPortal, isProOrEntTrial, scopes);
  useTrialBadge({
    isPaid: isPaidPortal,
    inTrial: isProOrEntTrial,
    isPaidLoaded,
    isProOrEntTrialLoaded
  });
  const isLoading = !isPaidLoaded || !isProOrEntTrialLoaded;
  if (isLoading) {
    return null;
  }
  return /*#__PURE__*/_jsx(ButtonWithDemoExitConfirmation, {
    component: GlobalToolbarLink,
    shouldRender: showStartTrialButton,
    id: TRIAL_PICKER_BUTTON_ID,
    iconName: ICON_NAMES.UPGRADE,
    itemName: "Free Trials",
    target: "_blank",
    href: `/trial-picker/${portalId}`,
    ariaLabelKey: "nav.tooltips.trialPicker",
    additionalListItemStyles: newListItemStyles
  });
});